import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import Resource from "@mapmycustomers/shared/types/entity/Resource";
import { Modal } from "@mapmycustomers/ui";

import { makeEmailResourcePublic } from "@app/store/email/actions";

const messages = defineMessages({
  description: {
    id: "email.resourceMakePublicModal.description",
    defaultMessage:
      "The selected resource does not have a public link and cannot be inserted. Would you like to create public link?",
    description: "Description for make resource public modal",
  },
  okButtonLabel: {
    id: "email.resourceMakePublicModal.okButtonLabel",
    defaultMessage: "Yes, make public",
    description: "Ok button label for make resource public modal",
  },
  title: {
    id: "email.resourceMakePublicModal.title",
    defaultMessage: "Public link required for inserting",
    description: "Title for make resource public modal",
  },
});

interface MakeResourcePublicModalProps {
  onCancel: () => void;
  onResourceUpdated: (resource: Resource) => void;
  resourceId: Resource["id"];
}

const EmailResourceMakePublicModal = ({
  onCancel,
  onResourceMakePublic,
  onResourceUpdated,
  resourceId,
}: MakeResourcePublicModalProps & typeof mapDispatchToProps) => {
  const intl = useIntl();

  const [resourceUpdating, setResourceUpdating] = useState(false);

  const handleMakePublic = useCallback(() => {
    setResourceUpdating(true);
    onResourceMakePublic({
      callback: (resource) => {
        setResourceUpdating(false);
        onResourceUpdated(resource);
      },
      failureCallback: () => {
        setResourceUpdating(false);
      },
      resourceId,
    });
  }, [onResourceMakePublic, onResourceUpdated, resourceId]);

  return (
    <Modal
      okButtonProps={{ loading: resourceUpdating }}
      okText={intl.formatMessage(messages.okButtonLabel)}
      onCancel={onCancel}
      onOk={handleMakePublic}
      open
      size="small"
      title={intl.formatMessage(messages.title)}
      type="confirm"
    >
      {intl.formatMessage(messages.description)}
    </Modal>
  );
};

const mapDispatchToProps = {
  onResourceMakePublic: makeEmailResourcePublic,
};

export default connect(null, mapDispatchToProps)(EmailResourceMakePublicModal);
